export default "__VITE_ASSET__CTTAFM9N__"